// extracted by mini-css-extract-plugin
export default {"card":"Card_card__0VMRw","cardImage":"Card_cardImage__Ti1Qc","cardText":"Card_cardText__NYG7s"};